import React from "react";
import ConnectionDataService from "../../services/connection.service";
import SignupDataService from "../../services/signup.service";
import UploadDataService from "../../services/upload.service";
import EmailDataService from "../../services/email.service";
import Button from "react-bootstrap/Button";
import Updated from "../Messages/Updated";
import './Connection.css';
import { Col } from "reactstrap";

class ConnectionDetails extends React.Component{
  
    constructor(props) {
        super(props);
        const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
        let userid = 0;
        this.handleAccept = this.handleAccept.bind(this);
        this.handleReject = this.handleReject.bind(this);
        if(isLoggedIn)
        {
        userid = window.localStorage.getItem("userid");
    
        }
        this.state = {
            userid: userid,
            interestuserid: this.props.interestuserid,
            interestemail : this.props.interestemail,
            mysteryimage: 'mystery.jpg',
            searchname : '',
            searchage : '',
            answer1 : '',
            answer2 : '',
            answer3 : '',
            question1 : '',
            question2  : '',
            question3 : '',
            isApprover: this.props.isApprover,
            onClose: this.props.onClose,
            status : 'Pending',
            stage : 0,
            downloads: []
        };
      }

      handleAccept(event) {

        event.preventDefault();
        let data = {
            status : 2
        }
        ConnectionDataService.update(this.state.userid, this.state.interestuserid,data)
        .then(response => {

            if(response.data.message == 1)
            {
                this.setState({status: 'Accepted'}); 
                this.setState({stage: 1}); 

                SignupDataService.get(this.state.interestuserid)
                .then(resp => {

                  let body ={
                    to: resp.data.email,
                    from: process.env.REACT_APP_COMPANY_EMAIL,
                    message : "<div>Your interest was reject. Please <a href='" + process.env.REACT_APP_COMPANY_DOMAIN + "#/connection'>Log in </a>and check the Connections section.</div>",
                    subject : "Hoya Saxas Interest"
                  }
          
                 // EmailDataService.sendEmail(body);
                });


            }
            else

            {
                this.setState({stage: 3}); 

            }

        });



      }

      handleReject(event) {

        event.preventDefault();
        let data = {
            status : 3
        }
        ConnectionDataService.update(this.state.userid, this.state.interestuserid,data)
        .then(response => {
                if(response.data.message == 1)
                {
                    this.setState({status: 'Rejected'}); 
                    this.setState({stage: 2}); 


                    SignupDataService.get(this.state.interestuserid)
                    .then(resp => {

                      let body ={
                        to: resp.data.email,
                        from: process.env.REACT_APP_COMPANY_EMAIL,
                        message : "<div>Your interest was reject. Please <a href='" + process.env.REACT_APP_COMPANY_DOMAIN + "#/connection'>Log in </a>and check the Connections section.</div>",
                        subject : "Hoya Saxas Interest"
                      }
              
                      // EmailDataService.sendEmail(body);
                    });

  



                }
                else
                {
                    this.setState({stage: 2}); 

                }

        });

      }

      componentDidMount() {
      
        let arrayList = [];
        UploadDataService.download(parseInt(this.state.interestuserid))
          .then(response => {

          if(response.data != '')
                         {

                          response.data.map(val  => {

                           let data = {
                                      id: val.id,
                                      fileLink: val.fileLink,
                                      userid: val.userid,
                                      filename: val.filename
                                
                                            }
                                
                             arrayList.push(data);

                              this.setState({
                                  downloads: [
                                      arrayList
                                             ]
                                 });
                                    })
                        }

          })
        .catch(e => {
        console.log(e);
          });

          let first = this.state.userid;
          let second = this.state.interestuserid;
          console.log(this.state.isApprover);
          if(parseInt(this.state.isApprover) === 1)
          {
            first = this.state.interestuserid;
            second = this.state.userid;
          }
  
        ConnectionDataService.getOneByInterest(parseInt(first), parseInt(second))
        .then(response => {

            
                //Get the profile of the user you show interest for.

                SignupDataService.get(parseInt(this.state.interestuserid))
                .then(response1 => {

                    let status = "Pending";

                    if(parseInt(response.data.status) === 1)
                    {
                        status = "Pending";
                    }
                    else if(parseInt(response.data.status) === 2)
                    {
                        status = "Accepted";
                    }
                    else if(parseInt(response.data.status) === 4)
                    {
                        status = "No Interest";
                    }
                    else
                    {
                        status = "Rejected";
                    }

                    //console.log(response.data.question1)
                    this.setState({searchage: response1.data.age});
                    this.setState({searchname: response1.data.name});
                    this.setState({answer1: response.data.answer1});
                    this.setState({answer2: response.data.answer2});
                    this.setState({answer3: response.data.answer3});
                    this.setState({question1: response.data.question1});
                    this.setState({question2: response.data.question2});
                    this.setState({question3: response.data.question3}); 
                    this.setState({status: status}); 
            }
    
                );
        }

      )


}

      render(){

        return (
            <div>
      {this.state.stage == 1 ? <Updated Color={'accept-color'} Message={'You have accepted your potential match.'}/> : ''}
      {this.state.stage == 2 ? <Updated Color={'reject-color'} Message={'You have rejected your potential match.'}/> : ''}
<div className="row col-md-10 offset-1 display-box" >
        <div className="col-md-12">
          {this.state.downloads.length > 0 ? 
              <div className="row col-md-12">
              {this.state.downloads.map(dat => dat.map(fat => (
                      <div className="row col-md-3 panel-size">
                        <Col className="border-img" md="12">  
                    <img  height="75" src={fat.fileLink} /><br/>
                    <label>{fat.filename}</label><br/>
                  </Col>
                  </div>
                 )
                 ))
               }
        
                </div>
        :
        <div className="col-md-12">
          <img className="image-transform" width="200px"  src={this.state.mysteryimage} alt="mystery image" />
        </div>
        }



        </div>
        <div className="col-md-12">
          Name : {this.state.searchname}
        </div>
        <div className="col-md-12">
          Age : {this.state.searchage}
        </div>
        <div className="col-md-12">
          Status : {this.state.status}
        </div>
        <div className="row col-md-12">
      <div className="row col-md-12 offset-1">
        <div className="form-text-color col-md-4 background-color width-size">
        
          <label>{this.state.question1}</label><br/>
          <label>{this.state.answer1}</label>
        </div>
        <div className="form-text-color col-md-3 background-color width-size">
        <label>{this.state.question2}</label><br/>
          <label>{this.state.answer2}</label>
        </div>
        <div className="form-text-color col-md-4 background-color width-size">
          <label>{this.state.question3}</label><br/>
          <label>{this.state.answer3}</label>
        </div>
     
      </div>



      {this.state.isApprover == 1 ?
      <div className="row col-md-12">
        <div className="col-md-5">
            <Button onClick={this.handleAccept} className="btn btn-success width-size">Accept</Button>
            </div>
            <div className="col-md-4">
            <Button onClick={this.handleReject} className="btn btn-info width-size">Not Interested</Button>
            </div>
     
        </div>
        : ''}
               
        </div>
    
        <div className="row col-md-1 offset-10">
            <Button onClick={this.state.onClose} className="btn btn-danger">Close</Button>
            </div>
      </div>
             
            </div>
        )

      }
}
 
export default ConnectionDetails;